import { countryApi } from "../../api";

const CountryService = {
  fetchDropdown: async (term: string) => {
    const response = await countryApi.fetchCustom(`/search?term=${term}`);
    return response.data;
  },
};

export default CountryService;
